import React from 'react';
import Button from 'components/DesignSystem/Button';
import './filters.scss';

interface FilterButtonProps {
  filterActive: boolean,
  onClick: () => void,
}

export default function FilterButton({
  filterActive,
  onClick,
}: FilterButtonProps) {
  const filterClassName = filterActive ? 'filter-button-active' : '';

  return (
    <Button
      id="filter-button"
      type="secondary"
      icon="filter"
      className={filterClassName}
      onClick={onClick}
    />
  );
}
